import { useAuthenticator } from "@aws-amplify/ui-react";

export function useCognitoGroup() {
  const { user } = useAuthenticator();
  const userSession = user?.getSignInUserSession();
  const cognitoGroup =
    userSession?.getAccessToken().payload["cognito:groups"]?.[0];
  const isMeritoGroup = cognitoGroup === "merito-group";

  return { cognitoGroup, isMeritoGroup };
}
